import { render, staticRenderFns } from "./RegisterSSO.vue?vue&type=template&id=1637cc00"
import script from "./RegisterSSO.vue?vue&type=script&lang=js"
export * from "./RegisterSSO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports